import axios from "axios";
import { BASE_URL } from "./Custom";
import { getToken } from "../custome/action";

// Scheduler service runs on port 8100
const SCHEDULER_BASE_URL = process.env.REACT_APP_SCHEDULER_BASE_URL || "http://localhost:8100";

export const syncOrder = async (channelId,action)=>{
    return axios.get(`${BASE_URL}/manageecom/api/syncOrder?channelId=${channelId}&action=${action}`, {
        headers: {
            'Authorization': 'Bearer ' + getToken(),
            'Content-Type': 'application/json'
        }
    })
}

export const syncActiveListings = async (userId, channelId) => {
    return axios.get(`${SCHEDULER_BASE_URL}/api/listings/sync?userId=${userId}&channelId=${channelId}`, {
        headers: {
            'Authorization': 'Bearer ' + getToken(),
            'Content-Type': 'application/json'
        }
    })
}